<template>
    <toolbar-option type="stacked" :message="message">
        <template slot="primary">
            <dropdown
                :options="displayOptions"
                :value="displayValue"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const CUSTOM_ATTR_NAME = 'dropdown-icon-display';
const DEFAULT_VALUE = 'toggle';

export default {
    name: 'control-nav-dropdown-icon-display',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Icon Display',
            displayValue: DEFAULT_VALUE,

            displayOptions: [
                { text: 'Hide', value: 'hide' },
                { text: 'Show', value: 'show' },
                { text: 'Toggle', value: 'toggle' },
            ],

            message: '* use "toggle" to switch between icons, depending on whether the dropdown is collapsed or expanded',
        };
    },

    methods: {
        onInput(displayValue) {
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, displayValue);
            this.onOptionChange(displayValue);
        },

        onSelectedElement() {
            this.displayValue = this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME) || DEFAULT_VALUE;
        },

        onConflict() {

        },
    },
};
</script>
